import React from 'react';
import {
  Avatar,
  Container,
  Snackbar,
  Typography,
  colors
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import logo from 'src/assets/images/konsep_2.jpg';
import { getUser } from 'src/utils/Common';
import PersonalCard from './PersonalCard';

const useStyles = makeStyles((theme) => ({
  root: {},
  cover: {
    position: 'relative',
    height: 200,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    '&:before': {
      position: 'absolute',
      content: '" "',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundImage: 'linear-gradient(-180deg, rgba(0,0,0,0.00) 58%, rgba(0,0,0,0.32) 100%)'
    },
    '&:hover': {
      '& $changeButton': {
        visibility: 'visible'
      }
    }
  },
  changeButton: {
    visibility: 'hidden',
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    backgroundColor: colors.blueGrey[900],
    color: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(3),
      bottom: 'auto'
    },
    '&:hover': {
      backgroundColor: colors.blueGrey[900]
    }
  },
  addPhotoIcon: {
    marginRight: theme.spacing(1)
  },
  container: {
    padding: theme.spacing(2, 3),
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  avatar: {
    border: `2px solid ${theme.palette.common.white}`,
    height: 120,
    width: 120,
    top: -60,
    left: theme.spacing(3),
    position: 'absolute'
  },
  details: {
    marginLeft: 136
  },
  actions: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1)
    },
    '& > * + *': {
      marginLeft: theme.spacing(1)
    }
  },
  pendingButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  },
  personAddIcon: {
    marginRight: theme.spacing(1)
  },
  mailIcon: {
    marginRight: theme.spacing(1)
  }
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const user = {
    name: SessionUser.FirstName +" " +SessionUser.LastName,
    bio: SessionUser.ServiceShopCode + " " + SessionUser.ServiceShopName,
    avatar: localStorage.getItem('UserPhoto'),
    cover: logo,
    connectedStatus: 'not_connected',
    Message: SessionUser.Message,
    TechnicianCode: SessionUser.TechnicianCode
  };
  const [connectedStatus] = useState(user.connectedStatus);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openUserCard, setOpenUserCard] = useState(false);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (connectedStatus === 'pending') {
      setOpenSnackbar(true);
    }
  }, [connectedStatus]);

  const handleUserCard = () => {
    if (window.location.href.includes('local') || window.location.href.includes('test')){
      setOpenUserCard(true)
    }
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div
        className={classes.cover}
        style={{ backgroundImage: `url(${user.cover})` }}
      >
       
      </div>
      <Container
        maxWidth="lg"
        className={classes.container}
      >
        <Avatar
          alt="Person"
          className={classes.avatar}
          src={user.avatar}
          onClick={handleUserCard}
        />        
        <div className={classes.details}>
          <Typography
            component="h2"
            gutterBottom
            variant="overline"
          >
            {user.bio}
          </Typography>
          <Typography
            component="h1"
            variant="h4"
            onClick={handleUserCard}
          >
            {user.name}
          </Typography>
        </div>
       
      </Container>
      <Snackbar 
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        autoHideDuration={6000}
        message={(
          <Typography
            color="inherit"
            variant="h6"
          >
            Sent connection request
          </Typography>
        )}
        onClose={handleSnackbarClose}
        open={openSnackbar}
      />
      <PersonalCard 
       openUserCard = {openUserCard}
       setOpenUserCard = {setOpenUserCard}
       user = {user}
      />
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
